import { render, staticRenderFns } from "./GoodsPreview.vue?vue&type=template&id=102ff7f8&scoped=true"
import script from "./GoodsPreview.vue?vue&type=script&lang=js"
export * from "./GoodsPreview.vue?vue&type=script&lang=js"
import style0 from "./GoodsPreview.vue?vue&type=style&index=0&id=102ff7f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102ff7f8",
  null
  
)

export default component.exports